import React, { useContext } from 'react';
import styled from 'styled-components';
import TagDiscount from '@com/core/noon/components/TagDiscount';
import { colors } from '@com/core/noon/styles/noonTheme';
import { breakpoints } from '@com/core/common/styles/baseStyles';
import { AppContext } from '../../../common/contexts/appContext';

type TProps = {
    price: number;
    salePrice?: number;
    size?: string;
    decimals?: number;
};

const Price = ({ decimals = 0, price, salePrice, size = 'regular' }: TProps): JSX.Element => {
    const { locale } = useContext(AppContext);
    const currency = locale.currencyCode;

    const sellingPrice = Number(salePrice || price).toFixed(decimals);
    let oldPrice = null;
    if (salePrice) {
        oldPrice = price > 0 ? Number(price).toFixed() : 0;
    }

    return (
        <Container>
            <SellingPrice className={size}>
                <span className="currency">{currency}</span>
                <strong>{sellingPrice}</strong>
            </SellingPrice>
            {oldPrice && oldPrice > 0 && (
                <PreReductionPrice>
                    <span className="oldPrice">
                        {currency} {oldPrice}
                    </span>
                    <TagDiscount price={price} salePrice={salePrice} />
                </PreReductionPrice>
            )}
        </Container>
    );
};

const Container = styled.div`
    line-height: 1;
    display: flex;
    flex-wrap: wrap;

    @media ${breakpoints.minTablet} {
        display: unset;
    }
`;

const SellingPrice = styled.div`
    display: flex;
    color: ${colors.bgSecondary};
    ${({ theme: { right } }): string => `margin-${right}: 4px`};

    .currency {
        align-items: unset;
        font-weight: bold;
    }

    strong {
        ${({ theme: { left } }): string => `margin-${left}: 4px`};
    }

    &.large {
        .currency {
            font-size: 1.2857rem;
        }

        strong {
            font-size: 1.2857rem;
        }
    }

    &.small {
        .currency {
            font-size: 1rem;
            margin-top: 3px;
        }

        strong {
            font-size: 1.4rem;
        }
    }
`;

const PreReductionPrice = styled.div`
    display: flex;
    align-items: center;
    color: ${colors.fontColorLight};
    font-size: 0.769rem;

    &.small {
        // todo
    }

    &.large {
        font-size: 0.8571rem;
        margin-top: 2px;
    }

    .oldPrice {
        text-decoration: line-through;
    }

    @media ${breakpoints.minTablet} {
        &.large {
            margin-top: 1px;
        }
    }
`;

export default Price;
